export default {
  code: 
`
 一纸邀约，十年光阴

 昔时少年，球场初逢，惊鸿一瞥，缘起于斯

 砥砺同行，寒窗共勉，蟾宫折桂，幸得同途

 缘起之时，蓉城再聚，四载韶华，锦里烟火暖朝夕。

 虽经南北，各赴鹏程，然情之所钟，千里不违

 终为鸳侣，共赴京华

 十年相知，一生之约。谨择良辰，敬备喜筵

 伏愿尊驾莅临，觥筹同庆，共证盟誓！`,
  executions: [{
    name:'缘分初始化',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'相遇中',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'相爱中',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'准备婚礼中',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'幸福加载中🙂',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'吃火锅中😄',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'甜蜜编译中...',
    time: '',
    visible: false
  }],
  barrages: [
    // 新人名字相关
    '孙诺 & 舒箫 新婚快乐',
    '诺箫夫妇 百年好合',
    '孙诺最帅！',
    '舒箫最美！',
    '孙诺&舒箫 天生一对',
    
    // 日期相关
    '2026.5.4 大喜之日',
    '五四青年节结婚，永远年轻',
    '五月的婚礼，最美的你们',
    
    // 地点相关
    '白银金凤凰酒店见',
    '人民路88号，不见不散',
    
    // 情书相关
    '十年相知，一生之约',
    '一纸邀约，十年光阴 ❤️',
    '从球场初逢到白头偕老',
    '蓉城四载，京华一生',
    
    // 程序员特色
    'Bug 修复了，可以结婚了！',
    '编译成功！婚姻程序已启动',
    '这行代码写的是：我爱你',
    '没有 Bug 的爱情',
    'merge 成功，永不冲突',
    
    // 传统祝福
    '白头偕老',
    '永结同心',
    '早生贵子',
    '琴瑟和鸣',
    '龙凤呈祥',
    '佳偶天成',
    '缘定三生',
    '相亲相爱',
    
    // 现代祝福
    '一定要幸福啊',
    '甜甜甜！',
    '🍬 🍭 🍫',
    '撒花！🎉',
    '举杯庆祝！🥂',
    
    // 走心祝福
    '愿你眼中总有光芒',
    '愿你活成自己想要的样子',
    '最好的爱情，最好的你们',
    '往后余生，都是彼此',
    '从校服到婚纱，从青丝到白发',
    
    // 幽默祝福
    '民政局给你们发VIP卡',
    '国家分配对象成功案例',
    '来喝喜酒啦！',
    '蹭蹭喜气',
    '我也想要甜甜的爱情',
    
    // 表情祝福
    '❤️ 🤵 👰 ❤️',
    '🎉 🎊 🎉',
    '💒 🏩 💒',
    '🥂 🍷 🥂',
    '🌸 🌺 🌸'
],
}